export default __webpack_public_path__ + "static/media/new-nomination-icon.468b3efb.svg";